import React from 'react';

import Button from 'components/Button/Button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogPortal,
  DialogTitle
} from 'components/ui';

type DisableConfirmDialogProps = {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export const DisableConfirmDialog: React.FC<DisableConfirmDialogProps> = ({
  isOpen,
  onCancel,
  onConfirm
}) => (
  <Dialog
    open={isOpen}
    onOpenChange={(open) => {
      if (!open) {
        onCancel();
      }
    }}
  >
    <DialogPortal>
      <DialogContent
        showCloseButton
        overlayClassName="bg-white/50 backdrop-blur-sm"
        className="z-[2001] max-w-[450px] bg-white p-6"
        onCloseAutoFocus={(e) => e.preventDefault()}
        data-testid="apps-flyer-s2s-disable-confirm"
      >
        <DialogHeader>
          <DialogTitle className="text-p-l font-semibold">
            Disable S2S Integration?
          </DialogTitle>
          <DialogDescription className="text-p-s text-base-mutedForeground">
            Are you sure you want to disable this S2S integration? This action
            may interrupt data synchronization and related workflows.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2">
          <Button
            variant="link"
            onClick={onCancel}
            data-testid="apps-flyer-s2s-disable-cancel"
          >
            Cancel
          </Button>
          <Button
            className="bg-base-foreground text-base-background hover:bg-base-foreground/90"
            onClick={onConfirm}
            data-testid="apps-flyer-s2s-disable-confirm-btn"
          >
            Disable
          </Button>
        </DialogFooter>
      </DialogContent>
    </DialogPortal>
  </Dialog>
);
